import PageLayer from "@/Layouts/views/PageLayer";
import SupportCenterLayer from "../Layers/SupportCenter/SupportCenterLayer";

// MUI
import { Stack, SvgIcon } from "@mui/material";

// Icons
import { ReactComponent as Icon } from "@/assets/icons/header/washouts/SupportCenter.svg";

export default function SupportCenter() {
	return (
		<PageLayer
			title="Support Center"
			icon={
				<Stack width={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
					<SvgIcon
						viewBox="-2 -2 24 24"
						className="text-[var(--medium-pink-color)] [&>g>path]:!fill-[var(--medium-pink-color)] !text-[27px]"
						component={Icon}
					/>
				</Stack>
			}
		>
			<SupportCenterLayer />
		</PageLayer>
	);
}
